import { useRouter } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Icon } from 'ucl/components/icon/Icon';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

export const AddMoreButtonsSection = () => {
  const router = useRouter();

  return (
    <View style={styles.container}>
      <ActionButton
        onPress={() => router.navigate(routes.menu)}
        startIcon={<Icon variant="add" {...hiddenAccessibilityPlatformProps} />}
        variant={ActionButtonVariants.OUTLINE}
        eventAttributes={{
          Name: t('addItemsLowerCase'),
        }}
        flex={1}
      >
        {t('addItems')}
      </ActionButton>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flex: 1,
    gap: 10,
  },
});
